import "./../style/gallery.css";
import React, { useEffect } from "react";

const imageUrls = [
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784136571/img1_fcitvd.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784136571/img3_qjzmr3.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784136572/img4_qotji7.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784136572/img2_utlc01.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137193/img5_yz67or.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137193/img6_unq4wy.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137193/img7_pbugug.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137193/img8_qx9sax.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137193/img9_sl1aq3.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137194/img10_bqxltf.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137194/img11_iwnw2n.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137194/img12_ngyzad.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137194/img13_ek1ltb.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137194/img14_sfuehy.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137194/img15_pvakaj.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137195/img16_ad1xkq.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137195/img17_ajwij2.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137195/img18_bp0odj.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137195/img19_fvmi6u.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137195/img20_mzddql.jpg",
  "https://res.cloudinary.com/n73s1fmx/image/upload/v1784137193/21_ahdxkd.jpg",
  "https://res.cloudinary.com/f3ok3wck/image/upload/f_auto/q_auto/img1.jpg",
  "https://res.cloudinary.com/f3ok3wck/image/upload/f_auto/q_auto/img2.jpg",
  "https://res.cloudinary.com/f3ok3wck/image/upload/f_auto/q_auto/img3.jpg",
  "https://res.cloudinary.com/f3ok3wck/image/upload/f_auto/q_auto/img4.jpg",
  "https://res.cloudinary.com/f3ok3wck/image/upload/f_auto/q_auto/img5.jpg",
  "https://res.cloudinary.com/f3ok3wck/image/upload/f_auto/q_auto/img6.jpg"


];

const GalleryPhoto = () => {
  useEffect(() => {
    const gallery = document.querySelector("#gallery");
    if (!gallery) return;

    const getVal = (elem, style) =>
      parseInt(window.getComputedStyle(elem).getPropertyValue(style));

    const getHeight = (item) =>
      item.querySelector(".content").getBoundingClientRect().height;

    const resizeAll = () => {
      const altura = getVal(gallery, "grid-auto-rows");
      const gap = getVal(gallery, "grid-row-gap");

      gallery.querySelectorAll(".gallery-item").forEach((item) => {
        item.style.gridRowEnd = `span ${Math.ceil(
          (getHeight(item) + gap) / (altura + gap)
        )}`;
      });
    };

    gallery.querySelectorAll("img").forEach((item) => {
      item.classList.add("byebye");

      if (item.complete) {
        item.classList.remove("byebye");
        resizeAll();
      } else {
        item.addEventListener("load", () => {
          resizeAll();
          item.classList.remove("byebye");
        });
      }
    });

    window.addEventListener("resize", resizeAll);

    gallery.querySelectorAll(".gallery-item").forEach((item) => {
      item.addEventListener("click", () => {
        item.classList.toggle("full");
      });
    });

    resizeAll();

    return () => {
      window.removeEventListener("resize", resizeAll);
    };
  }, []);

  return (
    <div>
      <div className="gallery" id="gallery">
        {imageUrls.map((imageUrl, index) => (
          <div key={index} className="gallery-item">
            <div className="content">
              <img
                data-aos="flip-left"
                src={imageUrl}
                alt={`Gallery ${index + 1}`}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryPhoto;
